// @flow
import React from 'react';
import classNames from 'classnames';
import {withStyles} from '@material-ui/core/styles';
import Widget from 'app/components/Widget';
import styles from './WidgetYektanet.styles';

class WidgetYektanet extends React.Component<Props> {
    componentDidMount() {
      this.init();
    }

    init = () => {
      const now = new Date();
      const head = document.getElementsByTagName('head')[0];
      let script = document.createElement('script');
      script.type = 'text/javascript';
      const method = this.props.method || 'banner';
      const script_addresses = {
        banner: 'https://cdn.yektanet.com/template/bnrs/yn_bnr.min.js'
      };
      script.src = script_addresses[method] + '?v=' + now.getFullYear().toString() + '0' + now.getMonth() + '0' + now.getDate() + '0' + now.getHours();
      head.appendChild(script);
    }

    render() {
      const {classes, className, idNumber} = this.props;

      return (
        <Widget className={{wrapper: classes.widgetWrapper, container: classes.widgetContainer}}>
          <div
            className={classNames('yn-bnr', className, classes.yektanet)}
            id={`ynpos-${idNumber}`}>
          </div>
        </Widget>
      );
    }
}

const Component = withStyles(styles)(WidgetYektanet);
export {Component as WidgetYektanet};
export default Component;